import { render, staticRenderFns } from "./dashboards-details.vue?vue&type=template&id=4378258b&scoped=true&"
import script from "./dashboards-details.vue?vue&type=script&lang=js&"
export * from "./dashboards-details.vue?vue&type=script&lang=js&"
import style0 from "./dashboards-details.vue?vue&type=style&index=0&id=4378258b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378258b",
  null
  
)

component.options.__file = "dashboards-details.vue"
export default component.exports